import { render, staticRenderFns } from "./SendFileToContacts.vue?vue&type=template&id=0cca4b38&"
import script from "./SendFileToContacts.vue?vue&type=script&lang=js&"
export * from "./SendFileToContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports